import { Pressable } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { getDesignToken, spacing } from 'styles/constants';
/**
 * Spreads children horizontally and centers them vertically
 */
export const SpreadContentContainer = ({
  children,
  style,
  ...props
}: React.PropsWithChildren<BoxProps>) => (
  <Box {...props} style={[styles.spreadContentContainer, style]}>
    {children}
  </Box>
);

/**
 * Adds space for an Accordion Item's content.
 */
export const AccordionContentWrapper = ({
  children,
  style,
  ...props
}: React.PropsWithChildren<BoxProps>) => (
  <Box {...props} style={[styles.accordionContentWrapper, style]}>
    {children}
  </Box>
);

/**
 * Unstyled button for triggering Accordion dropdowns.
 */
export const AccordionActivatorButton = Pressable.withConfig({
  width: 'full',
  paddingY: '$4',
  paddingX: '$8',
  background: 'transparent',
});

export const AccordionWrapper = ({
  children,
  style,
  ...props
}: React.PropsWithChildren<BoxProps>) => (
  <Box {...props} style={[styles.accordionWrapper, style]}>
    {children}
  </Box>
);

const styles = StyleSheet.create({
  spreadContentContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  accordionContentWrapper: {
    marginBottom: spacing.$4,
    marginRight: spacing.$4,
    marginTop: spacing.$8,
    paddingHorizontal: spacing.$8,
    width: '100%',
  },
  accordionWrapper: {
    borderBottomWidth: 1,
    borderColor: getDesignToken('border-color-default'),
    marginHorizontal: spacing.$4,
  },
});
